import { render, staticRenderFns } from "./showRefs.vue?vue&type=template&id=03800f47&"
import script from "./showRefs.vue?vue&type=script&lang=js&"
export * from "./showRefs.vue?vue&type=script&lang=js&"
import style0 from "./showRefs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports